import { selectVehicleByTrim } from '../reducers/vehicles';
import { useAppSelector } from '../utils';
import useFetchPayment from './useFetchPayment';
/**
 * Fetch payment data for a trim with optional transmission.
 * Model year, model, exterior color, interior color, and vehicle type are optional.
 *
 * @param {string} trimKey Trim key
 * @param {string} [transmissionKey] Transmission key; if not provided, default transmission is used
 * @param {string} [modelYear] Model year; if not provided, state.vehicles[trimKey]
 * @param {string} [modelKey] Model key; if not provided, state.vehicles[trimKey]
 * @param {string} [exteriorColorKey] Exterior color key; if not provided, default exterior color is used
 * @param {string} [interiorColorKey] Interior color key; if not provided, default interior color is used
 * @param {string} [vehicleType] Type of vehicle
 * @return {*}
 */
export const useFetchTrimPayment = (trimKey, paymentOptions, transmissionKey, modelYear, modelKey, exteriorColorKey, interiorColorKey, vehicleType) => {
    var _a, _b;
    const trim = useAppSelector(state => selectVehicleByTrim(state, trimKey));
    const transmission = transmissionKey
        ? (_a = trim === null || trim === void 0 ? void 0 : trim.transmissions) === null || _a === void 0 ? void 0 : _a.find((t) => t.transmissionKey === transmissionKey)
        : (_b = trim === null || trim === void 0 ? void 0 : trim.transmissions) === null || _b === void 0 ? void 0 : _b.find((t) => t.transmissionKey === (trim === null || trim === void 0 ? void 0 : trim.defaultTransmission));
    return useFetchPayment({
        trimKey: trim === null || trim === void 0 ? void 0 : trim.trimKey,
        modelKey: modelKey || (trim === null || trim === void 0 ? void 0 : trim.modelKey),
        modelYear: modelYear || (trim === null || trim === void 0 ? void 0 : trim.modelYear),
        transmissionKey: transmission === null || transmission === void 0 ? void 0 : transmission.transmissionKey,
        exteriorColorKey: exteriorColorKey || (transmission === null || transmission === void 0 ? void 0 : transmission.exteriorColorKey),
        interiorColorKey: interiorColorKey || (transmission === null || transmission === void 0 ? void 0 : transmission.interiorColorKey),
        accessories: [],
        protections: [],
        protectionAddOns: [],
    }, paymentOptions, vehicleType);
};
export default useFetchTrimPayment;
